const CookieNames = Object.freeze({
    NOTIFICATION: 'vid_notification', // Registration cookie
    USER_PROFILE: 'vid_userProfile',
    LOGIN_PREFILL_USER: 'vid_loginPrefillUser',
    SESSION_EXPIRATION_TIMESTAMP: 'vid_sessionExpirationTimestamp',
});

export default CookieNames;
